function required(name) {
  const value = process.env[name]?.trim();

  if (!value) {
    throw new Error(`${name} is required. Set it in crm-frontend/.env`);
  }

  return value;
}

export const env = {
  apiBaseUrl: required('REACT_APP_API_BASE_URL'),
};
